


































import { Component } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';

// Components
import ElementBgIcon from '@/components/elements/ElementBgIcon.vue';

@Component({
  components: {
    ElementBgIcon,
  },
})
export default class DialogUpdateAvailable extends MixinDialog {
  get version() {
    return this.$pdc.update!.version;
  }

  get next() {
    return this.$pdc.update!.next;
  }

  get nextSplitted() {
    return this.next?.split('.');
  }

  get updateAvailable() {
    return this.$pdc.update!.updateAvailable;
  }

  reload() {
    window.location.reload();
  }
}
